export default{
    requests(state,_,rootState){
        const coachId = rootState.userId
        return state.requests.filter(request=> request.coachId === coachId)
    },
    hasRequests(_,getters){
        return getters.requests && getters.requests.length > 0
    }
}